const getters = {
  localPosition: state => state.localPosition,
  autoinfo: state => state.autoinfo,
  unionid: state => state.unionid,
  searchCondition: state => state.searchCondition,
  city: state => state.city,
  searchModule: state => state.searchModule,
  mealDetail: state => state.mealDetail,
  orderUserInfo: state => state.orderUserInfo,
  dateChosen: state => state.dateChosen,
  voucher: state => state.voucher,
  mealPersonInfo: state => state.mealPersonInfo,
  switchCity: state => state.switchCity,
  echartsData: state => state.echartsData,
  assessmentData: state => state.assessmentData,
  selectItemList: state => state.selectItemList,
  selectItemContentList: state => state.selectItemContentList,
  addItemPrice: state => state.addItemPrice,
  recommendResult: state => state.recommendResult,
  medicineChineseConfig: state => state.medicineChineseConfig,
  deviceOpenId: state => state.deviceOpenId,
  deviceUserDetails: state => state.deviceUserDetails,
  medicineChineseIdentifyType: state => state.medicineChineseIdentifyType,
  orderDetail: state => state.orderDetail,
  invoiceDetail: state => state.invoiceDetail,
  invoiceMoreInfo: state => state.invoiceMoreInfo,
  isFirst: state => state.isFirst,
  questionRobotInfo: state => state.questionRobotInfo
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js